export default __webpack_public_path__ + "../images/production-3.jpg";